import styled, { css } from "styled-components";

export const LoadersWrap = styled.div`
  ${({ theme }) => css`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1040;
    background: rgba(0, 0, 0, 0.7);
    overflow: hidden;
    width: 100%;
    height: 100%;
  `}
`;

export const LoadersImage = styled.img`
  ${({ theme }) => css`
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 1050;
    margin: auto;
    margin-left: -20px;
  `}
`;
